module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js!./travel-mt.cfwidget.tsx"));
	}, "travel");
}